/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Sent_TextInputs */



/**
* | output |
* | --- |
* | "Thank you. The operations team will come back to you." |
*
* @param {Contact_Sent_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const contact_sent_text = /** @type {((inputs?: Contact_Sent_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Sent_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("谢谢。运营团队会尽快回复您。")
	return /** @type {LocalizedString} */ ("Thank you. The operations team will come back to you.")
});